<div>
  <h2 mat-dialog-title>Create a new User</h2>
  <mat-dialog-content>
    <p>
      Once the new user is created, the user will receive an email to the
      submitted address with instructions on how to login into their account.
    </p>

    <form [formGroup]="newUserForm">
      <mat-form-field class="m-2">
        <mat-label>Choose User</mat-label>
        <mat-select [formControl]="roleId">
          @for (role of roleIds; track role) {
          <mat-option [value]="role.value">{{ role.viewValue }}</mat-option>
          }
        </mat-select>
        @if (this.roleId.hasError('required')) {
        <mat-error>A user role is required.</mat-error>
        }
      </mat-form-field>

      @if (roleId.value == 1) {
      <mat-form-field class="m-2">
        <mat-label> Vendor Name </mat-label>
        <input matInput type="text" formControlName="vendorName" maxlength="" />
        @if (newUserForm.controls.vendorName.hasError('required')) {
        <mat-error>Vendor name is required.</mat-error>
        }
      </mat-form-field>
      } @if (roleId.value != 2) {
      <mat-form-field class="m-2">
        <mat-label> Email Address</mat-label>
        <input matInput type="email" formControlName="email" maxlength="" />
        @if (newUserForm.controls.email.hasError('email') &&
        !newUserForm.controls.email.hasError('required')) {
        <mat-error>Please enter a valid email address.</mat-error>
        } @if (newUserForm.controls.email.hasError('required')) {
        <mat-error>Email is required.</mat-error>

        }
      </mat-form-field>
      } @if (roleId.value == 2) {
      <mat-form-field>
        <mat-label> Student Email Address</mat-label>
        <input matInput type="email" formControlName="eduEmail" maxlength="" />
        @if ( newUserForm.controls.eduEmail.hasError('required')) {
        <mat-error>Student email is required.</mat-error>
        } @if ( newUserForm.controls.eduEmail.hasError('email')) {
        <mat-error>A valid email is required.</mat-error>
        } @if ( newUserForm.controls.eduEmail.hasError('noEduEmail')) {
        <mat-error>Email must include '.edu'.</mat-error>
        }
      </mat-form-field>
      }
      <div>
        <mat-form-field class="m-2">
          <mat-label> First Name</mat-label>
          <input
            matInput
            type="text"
            formControlName="firstName"
            maxlength=""
          />
          @if (newUserForm.controls.firstName.hasError('required')) {
          <mat-error>First name is required.</mat-error>
          }
        </mat-form-field>

        <mat-form-field class="m-2">
          <mat-label> Last Name</mat-label>
          <input matInput type="text" formControlName="lastName" maxlength="" />
          @if (newUserForm.controls.lastName.hasError('required')) {
          <mat-error>Last name is required.</mat-error>
          }
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button (click)="onCancel()">Cancel</button>
    <button
      mat-raised-button
      color="accent"
      (click)="createUser()"
      [disabled]="this.newUserForm.invalid"
    >
      Create
    </button>
  </mat-dialog-actions>
</div>
